import React, { useState, useEffect, useRef } from 'react';
import {
  Box,
  GDSStyleObject,
  Select,
  FormField,
  UtilityText,
} from '@leagueplatform/genesis-core';
import COBQuestioner from '../../../assets/json/COB_QUESTIONER.json';
import './style_calendar.css';

interface LabeledValue {
  currentDate?: any;
  selectedFormatDate?: any;
  showError?: boolean;
  errorMessage?: string;
  selectedDataValue?: any;
  isEmptyDate?: boolean;
  isFutureLimitYear?: boolean;
  limitYear?: number;
  setWidth?: string;
}

export function Calendar(props: LabeledValue) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const {
    currentDate,
    selectedFormatDate,
    showError,
    errorMessage,
    selectedDataValue,
    isEmptyDate,
    isFutureLimitYear,
    limitYear,
    setWidth,
  } = props;
  const yearDropDown = useRef<HTMLSelectElement>(null);
  const monthDropDown = useRef<HTMLSelectElement>(null);
  const dayDropdown = useRef<HTMLSelectElement>(null);

  let selectedMonth: any;
  let selectedYear: any;
  // let selectedDate: any;
  let calendarDays: any = [];
  let calendarYear: any = useRef;

  const [currentMonth, setCurrentMonth] = useState('');
  const [currentYear, setCurrentYear] = useState('');
  const [currentDay, setCurrentDay] = useState('');

  const year = COBQuestioner.COB.UTILS.YEAR;
  const month = COBQuestioner.COB.UTILS.MONTH;
  const date = COBQuestioner.COB.UTILS.DATE;

  useEffect(() => {
    if (isEmptyDate) {
      setCurrentMonth('');
      setCurrentYear('');
      setCurrentDay('');
    }
  }, [isEmptyDate]);

  calendarDays = [
    { key: '', value: '', label: date },
    { key: '1', value: '01', label: '1' },
    { key: '2', value: '02', label: '2' },
    { key: '3', value: '03', label: '3' },
    { key: '4', value: '04', label: '4' },
    { key: '5', value: '05', label: '5' },
    { key: '6', value: '06', label: '6' },
    { key: '7', value: '07', label: '7' },
    { key: '8', value: '08', label: '8' },
    { key: '9', value: '09', label: '9' },
    { key: '10', value: '10', label: '10' },
    { key: '11', value: '11', label: '11' },
    { key: '12', value: '12', label: '12' },
    { key: '13', value: '13', label: '13' },
    { key: '14', value: '14', label: '14' },
    { key: '15', value: '15', label: '15' },
    { key: '16', value: '16', label: '16' },
    { key: '17', value: '17', label: '17' },
    { key: '18', value: '18', label: '18' },
    { key: '19', value: '19', label: '19' },
    { key: '20', value: '20', label: '20' },
    { key: '21', value: '21', label: '21' },
    { key: '22', value: '22', label: '22' },
    { key: '23', value: '23', label: '23' },
    { key: '24', value: '24', label: '24' },
    { key: '25', value: '25', label: '25' },
    { key: '26', value: '26', label: '26' },
    { key: '27', value: '27', label: '27' },
    { key: '28', value: '28', label: '28' },
    { key: '29', value: '29', label: '29' },
    { key: '30', value: '30', label: '30' },
    { key: '31', value: '31', label: '31' },
  ];

  const calendarMonth = [
    { key: '', value: '', label: month },
    { key: '1', value: '1', label: 'Jan' },
    { key: '2', value: '2', label: 'Feb' },
    { key: '3', value: '3', label: 'Mar' },
    { key: '4', value: '4', label: 'Apr' },
    { key: '5', value: '5', label: 'May' },
    { key: '6', value: '6', label: 'Jun' },
    { key: '7', value: '7', label: 'Jul' },
    { key: '8', value: '8', label: 'Aug' },
    { key: '9', value: '9', label: 'Sep' },
    { key: '10', value: '10', label: 'Oct' },
    { key: '11', value: '11', label: 'Nov' },
    { key: '12', value: '12', label: 'Dec' },
  ];

  const convertToList = (content: any) => {
    const contentList = [];
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i <= content.length - 1; i++) {
      const index = i.toString();
      const currentValue = content[i].toString();
      if (i === 0) {
        contentList.push({
          key: '',
          value: '',
          label: year,
        });
        contentList.push({
          key: index,
          value: currentValue,
          label: currentValue,
        });
      } else {
        contentList.push({
          key: index,
          value: currentValue,
          label: currentValue,
        });
      }
    }
    return contentList;
  };

  const getAllDaysInMonth = (checkMonth: any, checkYear: any) =>
    Array.from(
      { length: new Date(checkYear, checkMonth, 0).getDate() }, // get next month, zeroth's (previous) day
      (_, i) => new Date(checkYear, checkMonth - 1, i + 1), // get current month (0 based index)
    );

  const convertDayList = (content: any) => {
    const contentDayList = [];
    for (let i = 0; i <= content.length - 1; i += 1) {
      const index = content[i].toString();
      const currentValue = content[i].toString();
      if (i < 9) {
        if (i === 0) {
          contentDayList.push({
            key: '',
            value: '',
            label: date,
          });
        }
        contentDayList.push({
          key: index,
          value: `0${currentValue}`,
          label: currentValue,
        });
      } else {
        contentDayList.push({
          key: index,
          value: `${currentValue}`,
          label: currentValue,
        });
      }
    }
    return contentDayList;
  };

  // eslint-disable-next-line consistent-return
  const setDateonChangeMonthYear = () => {
    const yearSelection = yearDropDown.current?.value;
    const monthSelection = monthDropDown.current?.value;
    const dateSelection = dayDropdown.current?.value;

    if (yearSelection !== '' && monthSelection !== '' && dateSelection !== '') {
      return selectedFormatDate(
        [yearSelection, monthSelection, dateSelection].join('-'),
      );
    }
  };

  const getYearDate = (type: string, curDate: any, curYear: any) => {
    let content: any = [];
    const allDatesInOctober = getAllDaysInMonth(curDate, curYear);
    content = allDatesInOctober.map((x) =>
      Number(x.toLocaleDateString([], { day: 'numeric' })),
    );
    return convertDayList(content);
  };

  const getYear = () => {
    let yearContent: any = [];
    let futureYearLimit = 10;
    futureYearLimit = isFutureLimitYear === undefined ? futureYearLimit : 0;
    const currentYearRange = new Date().getFullYear() + futureYearLimit;

    yearContent = Array.from(
      { length: limitYear || 100 },
      (_, i) => currentYearRange - i,
    );
    if (Number(currentMonth) && Number(currentYear)) {
      calendarDays = getYearDate(
        date,
        Number(currentMonth),
        Number(currentYear),
      );
    }
    return convertToList(yearContent);
  };
  calendarYear = getYear();

  function adjustDate() {
    let passYear;
    let passMonth;
    if (selectedMonth) {
      setCurrentMonth(selectedMonth);
    }
    if (selectedYear) {
      setCurrentYear(selectedYear);
    }
    if (yearDropDown.current?.value && monthDropDown.current?.value) {
      passYear = yearDropDown.current?.value;
      passMonth = monthDropDown.current?.value;
      if (!Number.isNaN(passMonth) && !Number.isNaN(passYear)) {
        getYearDate(date, passMonth, passYear);
      }
    }
  }

  const onUpdateDateFormat = (event: any) => {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const { value, id } = event.target;
    switch (id) {
      case 'month':
        selectedMonth = value;
        calendarDays = adjustDate();
        if (yearDropDown.current?.value && monthDropDown.current?.value) {
          setDateonChangeMonthYear();
        }
        if (selectedDataValue) {
          selectedDataValue(true);
        }
        break;
      case 'date':
        setCurrentDay(value);
        setDateonChangeMonthYear();
        if (selectedDataValue) {
          selectedDataValue(true);
        }
        break;
      case 'year':
        selectedYear = value;
        calendarDays = adjustDate();
        if (yearDropDown.current?.value && monthDropDown.current?.value) {
          setDateonChangeMonthYear();
        }
        if (selectedDataValue) {
          selectedDataValue(true);
        }
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (!isEmptyDate) {
      if (currentMonth) {
        setCurrentMonth(currentMonth.toString());
      }
    }

    if (
      currentDate !== '' &&
      currentDate !== 'undefined' &&
      currentDate !== undefined
    ) {
      const containsSlash = currentDate.includes('/');
      let getDate;
      if (containsSlash) {
        const getSlashedDestructuring = currentDate?.split('/');
        getDate = [
          getSlashedDestructuring[2],
          getSlashedDestructuring[1],
          getSlashedDestructuring[0],
        ]
          .join('-')
          .split('-');
      } else {
        getDate = currentDate?.split('-');
      }

      const mon = parseInt(getDate[1], 10);
      setCurrentMonth(mon?.toString());
      setCurrentYear(getDate[0]?.toString());
      setCurrentDay(getDate[2]?.toString());
    }
  }, [currentDate, currentMonth, currentYear, currentDay, isEmptyDate]);

  return (
    <Box className="dropdown-calendar">
      <Box
        css={
          {
            display: 'flex',
          } as GDSStyleObject
        }
      >
        <Box
          css={
            {
              display: 'flex',
              marginRight: '10px',
            } as GDSStyleObject
          }
        >
          <FormField
            id="month"
            label=""
            statusIconLabel="Error"
            inputStatus={showError ? 'error' : undefined}
          >
            <Select
              options={calendarMonth}
              id="month"
              aria-label="Month"
              css={{
                width: '116px',
                maxWidth: '116px',
                '@mobile': {
                  width: setWidth,
                  maxWidth: setWidth,
                },
              }}
              value={currentMonth}
              onChange={onUpdateDateFormat}
              ref={monthDropDown}
            />
          </FormField>
        </Box>
        <Box
          css={
            {
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              marginRight: '10px',
            } as GDSStyleObject
          }
        >
          <FormField
            id="date"
            label=""
            statusIconLabel="Error"
            inputStatus={showError ? 'error' : undefined}
          >
            <Select
              options={calendarDays}
              id="date"
              aria-label="Date"
              css={{
                width: '116px',
                maxWidth: '116px',
                '@mobile': {
                  width: setWidth,
                  maxWidth: setWidth,
                },
              }}
              value={currentDay}
              onChange={onUpdateDateFormat}
              ref={dayDropdown}
            />
          </FormField>
        </Box>
        <Box
          css={
            {
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            } as GDSStyleObject
          }
        >
          <FormField
            id="year"
            label=""
            statusIconLabel="Error"
            inputStatus={showError ? 'error' : undefined}
          >
            <Select
              options={calendarYear}
              id="year"
              aria-label="Year"
              css={{
                width: '116px',
                maxWidth: '116px',
                '@mobile': {
                  width: setWidth,
                  maxWidth: setWidth,
                },
              }}
              value={currentYear}
              onChange={onUpdateDateFormat}
              ref={yearDropDown}
            />
          </FormField>
        </Box>
      </Box>
      {showError && (
        <Box>
          <svg
            className="tinyClear"
            id="tinyClear"
            xmlns="http://www.w3.org/2000/svg"
            fill="red"
            viewBox="0 0 16 16"
          >
            <path
              fill="currentColor"
              fillRule="evenodd"
              d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Zm3.73-11.73a.75.75 0 0 1 0 1.06L9.06 8l2.67 2.67a.75.75 0 1 1-1.06 1.06L8 9.06l-2.67 2.67a.75.75 0 0 1-1.06-1.06L6.94 8 4.27 5.33a.75.75 0 0 1 1.06-1.06L8 6.938l2.67-2.67a.75.75 0 0 1 1.06 0Z"
              clipRule="evenodd"
            />
          </svg>

          <UtilityText
            css={
              {
                margin: 0,
                fontSize: '$caption',
                fontWeight: '$caption',
                fontFamily: '$caption',
                lineHeight: '$caption',
                letterSpacing: '$caption',
                textTransform: '$caption',
                textDecoration: '$caption',
                color: '$onSurfaceTextCritical',
              } as GDSStyleObject
            }
          >
            {errorMessage}
          </UtilityText>
        </Box>
      )}
    </Box>
  );
}
